import{inject as e}from"vue";var p=o=>{e("posthog")?.capture("$pageview",{path:o})},n=o=>{e("posthog")?.capture("$pageleave",{path:o})},i=(o,t={})=>{e("posthog")?.capture(o,t)};export{p as a,n as b,i as c};
